import cx from 'classnames';
import React, { useState, useEffect, memo, useRef, forwardRef, useCallback, useMemo } from 'react';
import isEmpty from 'lodash/isEmpty';
import { ButtonGroup, Carousel, ToggleButton } from 'react-bootstrap';
import styles from '../assets/scss/modules/_previewUI.module.scss';
import { CloseIcon } from '../components/icons/CloseIcon';
import _ from 'lodash';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';
import { deepEqual, handleScrollPage, isTransparentImage, wait } from '../helpers/jsHelper';
import Loader from '../components/Loader/Loader';
import NoDataFound from './NoDataFound';
import { isUserOnboardingNonCurator } from '../components/gamificationTooltip/helpers';
import { checkIfEmailIsVerifiedOrNot, useUserContext } from '../contexts/UserContext';
import MeasurementLayer from './MeasureTool/MeasurementLayer';
import { errorToast } from '../helpers/toastHelper';
import { useSelector } from 'react-redux';
import { MeasureToolContainer } from './MeasureTool/MeasureToolContainer';
import { apiGetToggleImageMeasure, apiGetImageMeasurementData, apiGetPublicImageMeasurementDataShare } from '../helpers/api.js';
import { dispatcher } from '../helpers/projectHelper';
import {
  measureToolActions,
  selectAddLineClicked,
  selectAllLineValues,
  selectImageMeasurementData,
  selectIsMeasureTool,
  selectIsPassChangedToPostEdit,
  selectIsStampingAllowed,
  selectLastClickIsReset,
  selectMeasureToolLoading,
  selectMeasureToolStyle,
  selectShowUnit,
  selectUnitValue,
} from '../redux/slicers/measureToolSlicer.js';
import { isCuratorPage } from '../helpers/urlHelper.js';
import { IMAGE_VARIATION_TYPE, PASS, RENDER_IMAGE_TYPE } from '../constants/renderPreviewConstants.js';
import { userPilotEvents } from './Userpilot/userpilotHelper.js';
import EditImageTool, { handleDownloadEditedImage } from '../components/EditImageTool.js';
import { selectActiveView } from '../redux/slicers/productV2Slicer.js';
import DownloadIcon from '../components/icons/DownloadIcon.js';
import { downloadFile } from '../api/curator.js';
import BigButton from './BigButton.js';
import { EDIT_IMAGE_TOOLS } from '../constants/constants.js';
import { PERMISSION } from '../constants/permissionConstants.js';
import { useStaticPermissions } from '../hooks/usePermissions.js';
import { getAppState } from '../redux/store.js';

export default function PreviewUIDisplay({
  id,
  theme,
  className = '',
  isFullscreen,
  onClose,
  title,
  actions,
  toggleFullscreen,
  slides = [],
  cards = [],
  activeIndex,
  setActiveIndex,
  activeCameraId,
  setActiveCameraId,
  classNameFullscreen,
  passOptions,
  pass,
  isTransparentBg,
  onPrevClick,
  onNextClick,
  setPass,
  roomImage,
  hideNextButton = false,
  hidePrevButton = false,
  parentChildren,
  loading,
  showNonCommericalText,
  isTutorialExperience = false,
  disablePreNextWhenOtherModalOpen = false,
  downloadLoading,
  isMeasureToolEditable,
  showMeasureTool,
  toggleOffMeasureTool,
  previewContainerStyle = {},
  carouselContainerStyle = {},
  isEditImageTool = false,
  setIsEditImageTool,
  imageToolData,
  setImageToolData,
  refreshData,
  editedImages, 
  setEditedImages,
  editImageLoading,
  setEditImageLoading,
  isFilmic
}) {
  const { trackImageVariationSelected, trackClickEvent } = userPilotEvents();
  const { currentUser, isFreemiumOrOldSubscriptionUser } = useUserContext();
  const [imageToolDownloadLoading, setImageToolDownloadLoading] = useState(false)
  const [showOriginalImage, setShowOriginalImage] = useState(false)
  const { hasPermission } = useStaticPermissions();
  const editedImagesRef = useRef(editedImages);
  const [anyChangeInEditImage, setAnyChangeInEditImage] = useState(false);
  const [finalEditedImage, setFinalEditedImage] = useState('');
  let imageEditConfig = getCurrentCamera()?.edit_config;

  useEffect(() => {
    if (slides?.length) {
      getYourEditedImage();
    }
  }, [slides, pass, isEditImageTool, imageEditConfig, activeCameraId])

  const getYourEditedImage = async () => {
    const myImage = await getEditedImage();
    setFinalEditedImage(myImage);
  }

  const isMeasureToolActive = useSelector(selectIsMeasureTool);
  useEffect(() => {
    window.addEventListener("mouseup", () => setShowOriginalImage(false))
    
    return () => {
      setTimeout(() => {
        window.$restrictFilter = null;
        handleScrollPage();
      }, 600);
      window.removeEventListener("mouseup", () => setShowOriginalImage(false))
    };
  }, []);
  const previewThumbnail = roomImage;

  const handleSelect = async (selectedIndex, event) => {
    let result;

    if (disablePreNextWhenOtherModalOpen) return;
    if (event.isPrevKeyPressed || event.target?.classList?.contains('carousel-control-prev')) {
      if (onPrevClick) {
        result = await onPrevClick();
      }
    } else {
      if (onNextClick) {
        result = await onNextClick();
      }
    }

    if (result === false) {
      return;
    }

    const currentImage = cards?.[selectedIndex]
    const isFilmicImgType = isFilmic

    if (currentImage?.edit_config)
      setImageToolData?.(currentImage?.edit_config);
    else 
      {
        setImageToolData?.({ 
        [EDIT_IMAGE_TOOLS.COLOR_CORRECTION]: { value: 0, originalValue: 0 },
        [EDIT_IMAGE_TOOLS.FILMIC_MODE]: { originalValue: isFilmicImgType ? 0 : 100, value: isFilmicImgType ? 0 : 100 }
      });
    } 

    setActiveIndex(selectedIndex);
    setActiveCameraId?.(cards[selectedIndex].id);
  };

  useKeyPress(
    {
      goNext: () => {
        if (isEditImageTool) return;
        const index = activeIndex + 1 < slides.length ? activeIndex + 1 : 0;
        if (!(hideNextButton && hidePrevButton)) {
          handleSelect(index, { isNextKeyPressed: true });
        }
      },
      goBack: () => {
        if (isEditImageTool) return;
        const index = activeIndex - 1 < 0 ? slides.length - 1 : activeIndex - 1;
        if (!(hideNextButton && hidePrevButton)) {
          handleSelect(index, { isPrevKeyPressed: true });
        }
      },
      showMeasureTool,
    },
    [activeIndex, slides]
  );

  const showCrossBtn = () => {
    if (isMeasureToolActive) {
      return !downloadLoading;
    } else if (!isFullscreen) {
      return true;
    } else {
      return false;
    }
  };

  const clickedCloseBtn = (e) => {
    if (isEditImageTool) {
      // dispatcher(measureToolActions.setLastClickedIsReset(false));
      setIsEditImageTool?.(false)
      setEditedImages({...editedImages, [activeCameraId]: null})
      editedImagesRef.current = {...editedImagesRef.current, [activeCameraId]: null}
      // Trigger post-edit image regeneration by dispatching the flag
      dispatcher(measureToolActions.setIsPassChangedToPostEdit(true));
      if (anyChangeInEditImage) {
        refreshData?.({showMainLoader: false});
        setAnyChangeInEditImage(false)
      }
      trackClickEvent('Cancel', {
        file_name:title,
        module_name:"Image Editor"
      })
      return
    }

    const initialLineValues = {
      measurements: [],
      widthInPx: 0,
      heightInPx: 0,
    };
    dispatcher(measureToolActions.setAllLineValues(initialLineValues));
    dispatcher(measureToolActions.setImageMeasurementData(null));
    onClose(e);
  };

  function getCurrentImage() {
    const currentImage = cards?.[activeIndex];
    if (pass === '3') {
      return (currentImage?.extra_color_pass_file || currentImage?.color_pass_file);
    }
    const isFilmicImgType = isFilmic;
    return isFilmicImgType ? (currentImage?.extra_filmic_file || currentImage?.filmic_file) : (currentImage?.extra_file || currentImage?.file)
  }

  function getOtherImage(){
    const currentImage = cards?.[activeIndex]
    const isFilmicImgType = isFilmic;
    return isFilmicImgType ? (currentImage?.extra_file || currentImage?.file) : (currentImage?.extra_filmic_file || currentImage?.filmic_file) 
  }

  function getColorPassImage(){
    const currentImage = cards?.[activeIndex]
    return (currentImage?.extra_color_pass_file || currentImage?.color_pass_file)
  }

  function getCurrentCamera() {
    return cards?.find(item => item?.id === activeCameraId)
  }

  // Download or return effect applied image
  function _handleDownloadEditedImage() {
    handleDownloadEditedImage({loading: setImageToolDownloadLoading, url: getCurrentImage(), imageToolData, otherImage: getOtherImage(), colorPassImage: getColorPassImage(), title})
  }

  async function getEditedImage() {
    if (pass !== PASS.POST_EDIT || !hasPermission(PERMISSION.IMAGE_EDITOR) || !Object.keys(getCurrentCamera()?.edit_config || {})?.length) {
      setFinalEditedImage(null);
      return null;
    }

    let imageEditConfig = getCurrentCamera()?.edit_config;

    // To stop extra re rendering added this condition
    // if json objects are different perform the operation otherwise return old value
    const editedImagesFromRef = editedImages?.[activeCameraId] || editedImagesRef.current?.[activeCameraId];
    const isPassChangedToPostEdit = selectIsPassChangedToPostEdit(getAppState());
    const lastClickedIsReset = selectLastClickIsReset(getAppState());

    // Force regeneration if:
    // 1. imageToolData differs from server config
    // 2. isPassChangedToPostEdit flag is set (e.g., after closing edit tool)
    // 3. No cached image exists
    const needsRegeneration = !deepEqual(imageToolData, imageEditConfig) || isPassChangedToPostEdit || !editedImagesFromRef;

    if (needsRegeneration) {
      setEditImageLoading(true);
      // When returning from edit image tool, always use server's edit_config
      if (isPassChangedToPostEdit) {
        dispatcher(measureToolActions.setIsPassChangedToPostEdit(false));
        // Use the server's edit_config, not the local imageToolData
        // Also sync imageToolData with server config
        setImageToolData?.(imageEditConfig);
      } else if (lastClickedIsReset && !anyChangeInEditImage) {
        imageEditConfig = imageToolData;
      }
      const editedImage = await handleDownloadEditedImage({ returnFile: true, url: getCurrentImage(), imageToolData: imageEditConfig, otherImage: getOtherImage(), colorPassImage: getColorPassImage(), title })
      editedImagesRef.current = { ...editedImagesRef.current, [activeCameraId]: editedImage }
      setEditImageLoading(false);
      return editedImage
    } else {
      if (editedImagesFromRef) {
        setEditImageLoading(false);
        return editedImagesFromRef;
      }
    }
  }

  return (
    <div
      style={isFullscreen ? { width: '100vw', height: '100vh', left: 0 } : previewContainerStyle}
      className={cx(
        styles.previewUI,
        isUserOnboardingNonCurator() && styles.leftZero,
        isFullscreen && styles.fullscreen,
        isFullscreen && classNameFullscreen,
        className,
        styles[theme],
        currentUser && !checkIfEmailIsVerifiedOrNot(false)
          ? !isCuratorPage()
            ? 'bottom-space'
            : ''
          : ''
      )}>
      {showCrossBtn() && (
        <button className={styles.closeButton} onClick={clickedCloseBtn}>
          <CloseIcon />
        </button>
      )}
      {showNonCommericalText && (
        <div
          className={styles.license}
          style={
            isTutorialExperience ? { bottom: !checkIfEmailIsVerifiedOrNot(false) ? 110 : 58 } : {}
          }>
          This image is under Non Commercial license
        </div>
      )}
      <div
        className={cx(
          styles.carouselContainer,
          'd-flex justify-content-center carousel slide',
          hideNextButton && styles.hideNextButton,
          hidePrevButton && styles.hidePrevButton,
          !loading && !slides.length && 'align-items-center'
        )}>
        {!loading && !slides.length && <NoDataFound height={'auto'} title={'Camera Angles'} />}
        {isEditImageTool ? 
          <EditImageTool
          id={activeCameraId}
          url={getCurrentImage()}
          showOriginalImage={showOriginalImage}
          data={imageToolData} 
          setData={setImageToolData} 
          setIsEditImageTool={setIsEditImageTool}
          otherImage={getOtherImage()} 
          colorPassImage={getColorPassImage()}
          setAnyChangeInEditImage={setAnyChangeInEditImage}
          callCloseFunc={clickedCloseBtn}
          pass={pass}
          title={title}
          />
        :
        slides?.length > 0 ? (
          <Carousel
            className={cx(styles.carousel, { fullScreenMode: isFullscreen === true })}
            activeIndex={activeIndex}
            onSelect={handleSelect}
            interval={null}
            keyboard={false}
            controls={true}>
            {slides.map((s, index) => (
              <Carousel.Item key={index}>
                <ZoomInImage
                  src={s ? s : previewThumbnail}
                  isFullscreen={isFullscreen}
                  isTransparentBg={isTransparentBg}
                  id={index}
                  isMeasureToolActive={isMeasureToolActive}
                  currentCard={cards[activeIndex]}
                  activeCameraId={activeCameraId}
                  downloadLoading={downloadLoading}
                  isMeasureToolEditable={isMeasureToolEditable}
                  showMeasureTool={showMeasureTool}
                  toggleOffMeasureTool={toggleOffMeasureTool}
                  loading={loading}
                  activeIndex={activeIndex}
                  disableTransform={false}
                  isPublicPage={!currentUser?.id}
                  // editedImage={getEditedImage()}
                  editedImage={finalEditedImage}
                  setEditedImages={setEditedImages}
                  imageToolData={imageToolData}
                  editImageLoading={editImageLoading}
                />
              </Carousel.Item>
            ))}
          </Carousel>
        ) : (
          <ZoomInImage
            src={slides?.length === 1 ? slides[0] : previewThumbnail}
            isFullscreen={isFullscreen}
            isTransparentBg={isTransparentBg}
            id="single-image"
            isMeasureToolActive={isMeasureToolActive}
            currentCard={cards[activeIndex]}
            activeCameraId={activeCameraId}
            downloadLoading={downloadLoading}
            isMeasureToolEditable={isMeasureToolEditable}
            showMeasureTool={showMeasureTool}
            toggleOffMeasureTool={toggleOffMeasureTool}
            loading={loading}
            activeIndex={activeIndex}
            disableTransform={false}
            isPublicPage={!currentUser?.id}
            // editedImage={getEditedImage()}
            editedImage={finalEditedImage}
            setEditedImages={setEditedImages}
            imageToolData={imageToolData}
            editImageLoading={editImageLoading}
          />
        )}
        
      </div>
      {/* {!isFullscreen && ( */}
      <>
        {passOptions?.length > 1 && !isTutorialExperience && !isEditImageTool && (
          <div
            className={cx(styles.passBtnContainer, ' d-flex justify-content-end')}
            style={{ position: 'absolute', bottom: 67, right: 10, zIndex: 999 }}>
            <ButtonGroup>
              {passOptions &&
                passOptions.map((p, i) => (
                  <ToggleButton
                    key={i}
                    id={`radio-${i}`}
                    type="radio"
                    variant="outline-primary"
                    name="pass"
                    value={p.value}
                    checked={pass === p.value}
                    onChange={(e) => {
                      if (!editImageLoading) {
                        setPass(e.currentTarget.value);
                        dispatcher(measureToolActions.setLastClickedIsReset(false));
                        trackImageVariationSelected({
                          variation_name: IMAGE_VARIATION_TYPE[p.value],
                          // TODO: add more data here
                        });
                      }
                    }}
                    className={pass === p.value ? 'pass-btn active' : 'pass-btn'}>
                    {p.name}
                  </ToggleButton>
                ))}
            </ButtonGroup>
          </div>
        )}

        <footer className={cx(styles.previewFooter, 'preview-display-footer')}>
          <h1 className="title">{title}</h1>

          {/* Hide footer button if editing image */}
          {!isEditImageTool ? !isEmpty(actions) && (
            <ul className="footer-action-list ced-action">
              {actions.map((a, index) => {
                const { element, ...rest } = a;
                const Component = element;
                return (
                  <Component
                    shareId={id}
                    id={`action${index}}`}
                    key={`action${index}}`}
                    {...rest}
                  />
                );
              })}

            </ul>
          ) : <div className='d-flex align-items-center justify-content-center gap-3 p-1 pe-3'>
            {/* <BigButton className="p-3 dark lf-btn-1 d-flex btn-v2" onMouseDown={() => {
              setShowOriginalImage(true)
            }}>Compare</BigButton> */}
            <BigButton isLoading={imageToolDownloadLoading} className="p-3 lf-btn-1 d-flex btn-v2" onClick={_handleDownloadEditedImage}><DownloadIcon /> Download</BigButton>
          </div>}
        </footer>
      </>
      {/* )} */}
      {parentChildren}
    </div>
  );
}

export const ZoomInImage = memo(
  forwardRef(
    (
      {
        isPublicPage,
        src,
        isFullscreen = false,
        isTransparentBg = false,
        id,
        currentCard,
        activeCameraId,
        downloadLoading,
        isMeasureToolEditable,
        showMeasureTool,
        toggleOffMeasureTool,
        loading,
        isMeasureToolActive,
        activeIndex,
        apiGetMeasurementData = isPublicPage ? apiGetPublicImageMeasurementDataShare : apiGetImageMeasurementData,
        disableTransform = false,
        transformWrapperProps = {},
        scale = 1,
        callbackWhenImageLoaded,
        hideLoading = false,
        onZoomCallback,
        isActiveId = false,
        editedImage,
        editedImages,
        setEditedImages,
        setAnyChangeInEditImage,
        isProductPage,
        editImageLoading
      },
      ref
    ) => {
      const [dimensionLoading, setDimensionLoading] = useState(false);
      const [imageLoading, setImageLoading] = useState(false);
      const timerRef = useRef(null);
      const itemRef = useRef(null);
      const imgRef = ref || useRef(null);
      const { isListView } = useSelector(selectActiveView);
      const lineValues = useSelector(selectAllLineValues);
      const allStyleSectionData = useSelector(selectMeasureToolStyle);
      const currentCameraMeasurement = useSelector(selectImageMeasurementData);
      const [disablePanning, setDisablePanning] = useState(false);
      const [localLoading, setLocalLoading] = useState(false);

      // console.log(editedImage, 'editedImage check check');      
      const [imageUrl, setImageUrl] = useState(src);
      //  useEffect(() => {
      //   if (imageLoading) {
      //     setTimeout(() => {
      //       clearLoading();
      //     }, 5000)
      //   }
      // }, [imageLoading])

      const onImageBoundsChanged = (str, obj) => {
        let copyValues = lineValues ? JSON.parse(JSON.stringify(lineValues)) : {};
        if (!copyValues) {
          copyValues = {};
        }
        if (currentCameraMeasurement?.measurements?.length && str !== 'init') {
          const currCam = JSON.parse(JSON.stringify(currentCameraMeasurement));
          copyValues['measurements'] = currCam.measurements;
          setTimeout(() => {
            dispatcher(measureToolActions.setMeasureToolLoading(false));
          }, 1000);
        }
        copyValues['widthInPx'] = obj?.width;
        copyValues['heightInPx'] = obj?.height;
        dispatcher(measureToolActions.setAllLineValues(copyValues));
        if (copyValues?.measurements?.length) {
          let styleApplied = copyValues.measurements[0].styleApplied;
          dispatcher(measureToolActions.setMeasureToolStyle(styleApplied));
        }
        setLocalLoading(false);
      };

      const getImageMeasurementData = async (id) => {
        if(!isActiveId && isListView) return 
        setDimensionLoading(true);
        const finalData = await apiGetMeasurementData?.(id);
        setDimensionLoading(false);
        if (finalData?.current_page_number) {
          dispatcher(
            measureToolActions.setImageMeasurementData(finalData?.results?.[0]?.data || null)
          );
          if (finalData?.results?.length) {
            dispatcher(measureToolActions.setUnitValue(finalData?.results?.[0]?.data?.unitValue));
            dispatcher(measureToolActions.setAllLineValues(finalData?.results?.[0]?.data || null));
          } else if (lineValues?.measurements?.length) {
            const values = imgRef?.current?.getBoundingClientRect();
            // if by any chase local variable has value but api returns no data
            const initialLineValues = {
              measurements: [],
              widthInPx: values?.clientWidth || values?.width || 0,
              heightInPx: values?.clientHeight || values?.height || 0,
            };
            dispatcher(measureToolActions.setImageMeasurementData(null));
            dispatcher(measureToolActions.setAllLineValues(initialLineValues));
          }
          if (!finalData?.results?.length) {
            dispatcher(measureToolActions.setMeasureToolLoading(false));
          }
        } else {
          errorToast('Something went wrong!');
        }
      };

      const getMeasureToolToggleValue = async (id) => {
        setDimensionLoading(true);
        const data = await apiGetToggleImageMeasure(id);
        setDimensionLoading(false);
        if (data?.id) {
          getImageMeasurementData(activeCameraId);
          dispatcher(measureToolActions.setIsMeasureToolActive(data?.is_measurement || false));
        }
      };

      useEffect(async () => {
        if (!currentCameraMeasurement?.noLoad) {
          setLocalLoading(true);
        }
        await wait(500);
        const imgRefValues = imgRef?.current?.getBoundingClientRect();
        const scaleLocal = currentCameraMeasurement?.scale || 1;
        if (imgRefValues?.height && imgRefValues?.width) {
          onImageBoundsChanged(null, {
            height: imgRefValues?.height / scaleLocal,
            width: imgRefValues?.width / scaleLocal,
          });
        } else {
          setLocalLoading(false);
        }
      }, [currentCameraMeasurement, activeIndex, isFullscreen]);

      useEffect(async () => {
        if (activeCameraId && id === activeIndex) {
          if (!loading) {
            if (isMeasureToolEditable) {
              getMeasureToolToggleValue(activeCameraId);
            } else {
              getImageMeasurementData(activeCameraId);
              dispatcher(measureToolActions.setIsMeasureToolActive(false));
            }
          }
        }
      }, [activeCameraId, loading, isListView]);

      useEffect(() => {
        const isEditedImage = Object.keys(currentCard?.edit_config || {})?.length
        if (src) {
          if (editedImage) {
            if (!isEditedImage || (imageUrl && editedImages?.[activeCameraId] === imageUrl)) {
              setImageUrl(src)
              return
            }
            setEditedImages(prev => ({ ...prev, [activeCameraId]: editedImage }))
            setImageUrl(editedImage)
          }
          else {
            setImageUrl(src)
          }

          // reason timeout -> we need loader only first time -> after that image is cached so no need for a loader when switching between images
          timerRef.current = setTimeout(() => {
            setImageLoading(true);
          }, 20);
        }
        else if (editedImage && !isEditedImage) {
          setImageUrl(null)
        }

        return () => {
          clearTimeout(timerRef.current);
        };
      }, [src, editedImage]);

      if ((!imageUrl || currentCard?.id !== activeCameraId) && !isProductPage) return null;
      const transparent = isTransparentImage(imageUrl);

      const clearLoading = (e, str) => {
        clearTimeout(timerRef.current);
        setImageLoading(false);
      };

      const updateLineStyle = (val) => {
        // setAllStyleSectionData(val);
        dispatcher(measureToolActions.setMeasureToolStyle(val));
        let copyValues = JSON.parse(JSON.stringify(lineValues));
        copyValues.measurements = copyValues.measurements.map((data) => {
          // if (data.selected) {
          data['styleApplied'] = val;
          // }
          return data;
        });
        dispatcher(measureToolActions.setAllLineValues(copyValues));
      };

      const { maxScale, panning, pinch, wheel, ...restTransformWrapperProps } =
        transformWrapperProps;
      if (disableTransform) {
        return (
          <ZoomInImageContent
            id={id}
            src={imageUrl}
            scale={scale}
            loading={hideLoading ? false : dimensionLoading || imageLoading || localLoading || editImageLoading}
            clearLoading={clearLoading}
            isFullscreen={isFullscreen}
            isTransparentBg={isTransparentBg}
            transparent={transparent}
            centerView={itemRef.current?.centerView}
            lineValues={lineValues}
            imgRef={imgRef}
            isMeasureToolActive={isMeasureToolActive}
            allStyleSectionData={allStyleSectionData}
            setAllStyleSectionData={(val) => updateLineStyle(val)}
            disablePan={(val) => setDisablePanning(val)}
            currentCard={currentCard}
            activeCameraId={activeCameraId}
            downloadLoading={downloadLoading}
            isMeasureToolEditable={isMeasureToolEditable}
            showMeasureTool={showMeasureTool}
            toggleOffMeasureTool={toggleOffMeasureTool}
            activeIndex={activeIndex}
            disableTransform={disableTransform}
            callbackWhenImageLoaded={callbackWhenImageLoaded}
          />
        );
      }

      return (
        <TransformWrapper
          onZoom={onZoomCallback}
          maxScale={maxScale || 3}
          centerOnInit
          pinch={{
            step: 0.5,
            ...(pinch || {}),
          }}
          wheel={{
            step: 0.02,
            ...(wheel || {}),
          }}
          doubleClick={{
            disabled: true,
            // mode: 'reset',
            // step: 1,
          }}
          panning={{
            ...(panning || {}),
            disabled: panning?.disabled || disablePanning,
            excluded: ['input'],
          }}
          {...restTransformWrapperProps}
          ref={itemRef}>
          {({ zoomIn, zoomOut, resetTransform, state, ...rest }) => {
            return (
              <ZoomInImageContent
                id={id}
                src={imageUrl}
                scale={state.scale}
                loading={hideLoading ? false : dimensionLoading || imageLoading || localLoading || editImageLoading}
                clearLoading={clearLoading}
                isFullscreen={isFullscreen}
                isTransparentBg={isTransparentBg}
                transparent={transparent}
                centerView={itemRef.current?.centerView}
                lineValues={lineValues}
                imgRef={imgRef}
                isMeasureToolActive={isMeasureToolActive}
                allStyleSectionData={allStyleSectionData}
                setAllStyleSectionData={(val) => updateLineStyle(val)}
                disablePan={(val) => setDisablePanning(val)}
                currentCard={currentCard}
                activeCameraId={activeCameraId}
                downloadLoading={downloadLoading}
                isMeasureToolEditable={isMeasureToolEditable}
                showMeasureTool={showMeasureTool}
                toggleOffMeasureTool={toggleOffMeasureTool}
                activeIndex={activeIndex}
                disableTransform={disableTransform}
                callbackWhenImageLoaded={callbackWhenImageLoaded}
              />
            );
          }}
        </TransformWrapper>
      );
    }
  )
);

const ZoomInImageContent = ({
  id,
  loading,
  scale,
  clearLoading,
  isFullscreen,
  src,
  isTransparentBg,
  transparent,
  centerView,
  lineValues,
  imgRef,
  isMeasureToolActive,
  allStyleSectionData,
  setAllStyleSectionData,
  disablePan,
  downloadLoading,
  isMeasureToolEditable,
  disableTransform = false,
  callbackWhenImageLoaded = null,
  activeCameraId,
}) => {
  const elementClassName = `lf-zoom-image-${id || activeCameraId}`;

  const [_scale, setScale] = useState(1);
  const [shouldRenderLayer, setShouldRenderLayer] = useState(false);
  useEffect(() => setScale(scale), [scale]);
  const showUnit = useSelector(selectShowUnit);
  const unitValue = useSelector(selectUnitValue);
  const { isListView } = useSelector(selectActiveView);
  const addLineClicked = useSelector(selectAddLineClicked);
  const isMeasureToolLoading = useSelector(selectMeasureToolLoading);
  const currentCameraMeasurement = useSelector(selectImageMeasurementData);
  const isStampingAllowd = useSelector(selectIsStampingAllowed);

  useEffect(() => {
    const copyValues = lineValues ? JSON.parse(JSON.stringify(lineValues)) : {};
    if (copyValues?.scale !== _scale) {
      onChange(copyValues.measurements, true);
    }
  }, [_scale]);

  // If the user double-clicks on the image, it zooms in (2x).
  // Now, if the user switches to a different image without exiting zoom mode,
  // we automatically reset the zoom to normal for the newly selected image.
  useEffect(() => {
    if (id?.toString() && +_scale > 1) {
      setScale(1);
      centerView?.(1);
    }
  }, [id]);

  useEffect(() => {
    if (loading) {
      dispatcher(measureToolActions.setMeasureToolLoading(loading));
    }
    setTimeout(() => {
      if (
        !loading &&
        isMeasureToolLoading &&
        !(lineValues?.measurements?.length && currentCameraMeasurement?.measurements?.length)
      ) {
        dispatcher(measureToolActions.setMeasureToolLoading(false));
      }
    }, 2000);
  }, [loading]);

  useEffect(() => {
    const handleDoubleClick = (e) => {
      if (
        !(
          e.target.localName === 'input' ||
          e.target?.classList?.value?.includes('grabber') ||
          e.target?.classList?.value?.includes('MeasureToolContainer') ||
          e.target?.classList?.value?.includes('circularProgress')
        )
      ) {
        _scale === 2 ? centerView?.(1) : centerView?.(2);
      }
    };

    const wrapper = document.querySelector(`.${elementClassName}`);

    if (!wrapper) return null;

    wrapper.addEventListener('dblclick', handleDoubleClick);
    return () => {
      wrapper.removeEventListener('dblclick', handleDoubleClick);
    };
  }, [_scale, Boolean(centerView)]);

  const calculateDistance = (line, physicalWidth, physicalHeight) => {
    const deltaX = (line.endX - line.startX) * physicalWidth;
    const deltaY = (line.endY - line.startY) * physicalHeight;
    return Math.hypot(deltaX, deltaY);
  };

  const onChange = (measurements, isAddLineClicked) => {
    const copyValues = JSON.parse(JSON.stringify(lineValues)) || {};
    copyValues['scale'] = _scale;
    copyValues['measurements'] = measurements;
    dispatcher(measureToolActions.setAllLineValues(copyValues));
    if (isAddLineClicked) {
      const measureData = JSON.parse(JSON.stringify(copyValues));
      measureData['noLoad'] = true;
      measureData['measurements'] = [];
      dispatcher(measureToolActions.setImageMeasurementData(measureData));
    }
  };

  const measureLine = (line) => Math.round(calculateDistance(line, 100, 100));

  const changeTextVal = (line, val) => {
    const copyMeasureValues = JSON.parse(JSON.stringify(lineValues.measurements));
    copyMeasureValues.forEach((data) => {
      if (data.id === line.id) {
        data['textValue'] = val;
        data['modified'] = true;
      }
    });
    onChange(copyMeasureValues);
  };

  const updateSelection = (val) => {
    const copyMeasureValues = JSON.parse(JSON.stringify(lineValues.measurements));
    copyMeasureValues.forEach((data) => {
      if (data.id === val) {
        data['selected'] = true;
        setAllStyleSectionData(data.styleApplied);
      } else {
        data['selected'] = false;
      }
    });
    onChange(copyMeasureValues);
  };

  const deselectAllLines = () => {
    const copyMeasureValues = JSON.parse(JSON.stringify(lineValues.measurements));
    copyMeasureValues.forEach((data) => {
      data['selected'] = false;
    });
    onChange(copyMeasureValues);
  };

  const setAddLineClicked = (val) => {
    dispatcher(measureToolActions.setAddLineClicked(val));
  };

  // here, i'm calling a callback when the image is loaded for the measure tool active only
  useEffect(() => {
    let timerId;
    // check if the lines view is present in the UI or not. if present then only call the callback
    const isLineViewPresent = document.querySelector(".lf-zoom-image-container .measurement-layer-base .line-measurement")
    if (isMeasureToolActive && !loading && callbackWhenImageLoaded && isLineViewPresent) {
      timerId = setTimeout(() => callbackWhenImageLoaded?.(), 3000);
    }
    return () => {
      if (timerId) clearTimeout(timerId);
    };
  }, [isMeasureToolActive, loading, callbackWhenImageLoaded, scale]);

  useEffect(() => {
    if (isMeasureToolActive && !loading) {
      // Added a 900ms delay to prevent the measurement line from shaking due to re-rendering caused by data updates.
      setTimeout(() => {
        setShouldRenderLayer(true);
      }, 900);
    } else {
      setShouldRenderLayer(false);
    }
  }, [isMeasureToolActive, loading]);

  const renderMeasurementLayer = useMemo(() => {
    if (!shouldRenderLayer) return null;
    return (
      <MeasurementLayer
        measurements={lineValues?.measurements || []}
        widthInPx={lineValues?.widthInPx}
        heightInPx={lineValues?.heightInPx}
        onChange={onChange}
        measureLine={measureLine}
        isFullscreen={isFullscreen}
        styleApplied={allStyleSectionData}
        changeTextVal={(line, val) => changeTextVal(line, val)}
        disablePan={disablePan}
        scale={_scale}
        downloadLoading={downloadLoading}
        isMeasureToolEditable={isMeasureToolEditable}
        updateSelection={(val) => updateSelection(val)}
        clickedOutsideAllLines={(val) => deselectAllLines(val)}
        addLineClicked={addLineClicked}
        setAddLineClicked={(val) => setAddLineClicked(val)}
        showUnit={showUnit}
        unitValue={unitValue}
        isListView={isListView}
      />
    );
  }, [shouldRenderLayer, lineValues, allStyleSectionData, _scale, downloadLoading, isFullscreen, addLineClicked, showUnit, unitValue, isStampingAllowd]);

  if (disableTransform) {
    return (
      <>
        <Loader position="absolute" loading={loading} backdropColor="dark" />
        <div
          style={{
            width: 'fit-content',
            height: 'fit-content',
            transform: 'translate3d(0px, 0px, 0px) scale(1)',
          }}
          className="d-flex align-items-center justify-content-center lf-zoom-image-container">
          <img
            src={src}
            alt="..."
            onLoad={(e) => clearLoading(e, 'load')}
            onError={(e) => clearLoading(e, 'error')}
            className={isTransparentBg || transparent ? 'lf-checker-png' : ''}
            style={{
              display: 'initial',
              maxWidth: '100%',
              maxHeight: '100%',
              opacity: loading ? 0.8 : 1,
            }}
            id="mainImage"
            ref={imgRef}
          />
          {renderMeasurementLayer}
        </div>
      </>
    );
  }

  return (
    <TransformComponent
      wrapperClass={elementClassName}
      id={'my-node'}
      contentStyle={{
        maxWidth: '100%',
        maxHeight: '100%',
        width: isFullscreen ? '100%' : 'calc(100vw - 225px)',
        height: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#333',
      }}
      wrapperStyle={{ width: '100%', height: '100%' }}>
      <Loader position="absolute" loading={loading} backdropColor="dark" />
      <img
        src={src}
        alt="..."
        onLoad={(e) => clearLoading(e, 'load')}
        onError={(e) => clearLoading(e, 'error')}
        className={isTransparentBg || transparent ? 'lf-checker-png' : ''}
        style={{
          display: 'initial',
          maxWidth: '100%',
          maxHeight: '100%',
          opacity: loading ? 0.8 : 1,
        }}
        id="mainImage"
        ref={imgRef}
      />
      {renderMeasurementLayer}
    </TransformComponent>
  );
};

function useKeyPress({ goNext, goBack, showMeasureTool }, deps) {
  const upHandler = (event) => {
    const KEY_CODE_LEFT = 37;
    const KEY_CODE_RIGHT = 39;

    const { keyCode } = event;

    if (!(document.getElementsByClassName('delete-button')?.length || showMeasureTool)) {
      if (keyCode === KEY_CODE_LEFT) {
        goBack();
      }

      if (keyCode === KEY_CODE_RIGHT) {
        goNext();
      }
    }
  };

  // Add event listeners
  useEffect(() => {
    window.addEventListener('keyup', upHandler);
    // Remove event listeners on cleanup
    return () => {
      window.removeEventListener('keyup', upHandler);
    };
  }, deps); // Ensures that effect is run on componentDidUpdate in addition to mount and unmount
}
